import React from 'react';
import Breadcrumb from '../../../layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from '../../../components/container/PageContainer';
import BlankCard from '../../../components/shared/BlankCard';
import BankListComponent from 'src/components/apps/bank/BankList';
import Bank from './Bank';

const BCrumb = [
  {
    to: '/',
    title: 'Home',
  },
  {
    title: 'Banks',
  },
];
const BankList = () => {
  const [open, setOpen] = React.useState(false);
  const [bank, setBank] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setBank('');
  };
  return (
    <PageContainer title="Banks" description="This is the bank list page.">
      {/* breadcrumb */}
      <Breadcrumb title="Banks" items={BCrumb} />
      <BlankCard>
        {/* ------------------------------------------- */}
        {/* Left part */}
        {/* ------------------------------------------- */}
        <BankListComponent handleClickOpen={handleClickOpen} setBank={setBank} />
      </BlankCard>
      <Bank open={open} handleClose={handleClose} bank={bank} />
    </PageContainer>
  );
};

export default BankList;
